import React, { useEffect } from 'react';
import { Button, Input, Table, Select, ContentsLayout, ContentsHeader } from 'src/components'
import styles from './Tenant.module.scss';

/**
 * Tenant コンポーネント
 * テナント情報
 * @returns React.ReactNode
 */
const Tenant: React.FC = () => {

  /**
   * GoogleAnalytics用トラッキング
   */
  useEffect(() => {
    window.gtag !== undefined && window.gtag('config', `${process.env.REACT_APP_DEV_TRACKING_ID}`, { page_path: window.location.pathname });
  }, []);

  return (
    <>
      <ContentsLayout>
        <ContentsHeader title="テナント管理">
          <Button>新規登録</Button>
        </ContentsHeader>
      </ContentsLayout>

      {/* <Table>
          <thead>
            <tr>
              <th>テナントID</th>
              <th>テナント名</th>
              <th>スラッグ</th>
              <th>logo</th>
              <th>緯度</th>
              <th>軽度</th>
              <th>ユーザー数</th>
              <th>備考</th>
              <th>編集</th>
            </tr>
          </thead>
          <tbody>
          </tbody>
        </Table> */}
    </>
  );
};

export default Tenant;